import {Component, Input} from '@angular/core';
import {Message} from '../../../contracts/message.interface';
import {MessageRendererComponent} from '../message-renderer/message-renderer.component';

@Component({
  standalone: true,
  selector: 'app-message-reply',
  imports: [
    MessageRendererComponent
  ],
  templateUrl: './message-reply.component.html',
  styleUrl: './message-reply.component.scss'
})
export class MessageReplyComponent {
  @Input() reply?: Message;
}
